import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CoinComponent } from './coin.component';
import { CoinChartsComponent } from './coin-charts/coin-charts.component';
import { CoinOverviewComponent } from './coin-overview/coin-overview.component';
import { TimeIntervalsComponent } from './coin-charts/time-intervals/time-intervals.component';
import { TradingViewChartComponent } from './coin-charts/trading-view-chart/trading-view-chart.component';

import { ShortNumberPipe } from './pipes/short-number.pipe';
import { RemoveExponentPipe } from './pipes/remove-exponent.pipe';

import { NgxEchartsModule } from 'ngx-echarts';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { NgbAccordionModule, NgbPaginationModule, NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';

/* Import Translate Module */
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from 'src/environments/environment';

import { MarqueeComponent } from '../standalone/components/marquee/marquee.component';
import { TrendingComponent } from '../standalone/components/trending/trending.component';
import { FiatValuePipe } from '../standalone/pipes/fiat-value.pipe';
import { AbsValuePipe } from '../standalone/pipes/abs-value.pipe';
import { PlaceValuePipe } from '../standalone/pipes/place-value.pipe';
import { TruncatePipe } from '../standalone/pipes/truncate.pipe';
import { DropdownListComponent } from '../standalone/components/dropdown-list/dropdown-list.component';
import { PaginationComponent } from '../standalone/components/pagination/pagination.component';
import { SortableDirective } from '../standalone/directives/sortable.directive';
import { CryptoNewsComponent } from '../standalone/components/crypto-news/crypto-news.component';
import { ImageComponent } from '../standalone/components/image/image.component';
import { CoinDetailResolver } from '../core/services/coin-detail.resolver';
import { TokenBannerComponent } from "../standalone/components/token-banner/token-banner.component";
import { LazyImgDirective } from '../standalone/directives/lazy-img.directive';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, environment.LANGUAGE_URL, '.json');
}

const routes: Routes = [
    { path: '', component: CoinComponent, resolve: { coinDetail: CoinDetailResolver } },
    { path: 'coins/:coinCode', component: CoinComponent, resolve: { coinDetail: CoinDetailResolver } },
    { path: 'coins/:coinCode/:section', component: CoinComponent, resolve: { coinDetail: CoinDetailResolver } }
];
@NgModule({
    declarations: [
        CoinComponent,
        CoinOverviewComponent,
        CoinChartsComponent,
        RemoveExponentPipe,
        ShortNumberPipe,
        TradingViewChartComponent,
        TimeIntervalsComponent
    ],
    imports: [
    CommonModule,
    FormsModule,
    NgbAccordionModule,
    NgbPaginationModule,
    ReactiveFormsModule,
    NgbProgressbarModule,
    TranslateModule,
    NgxSkeletonLoaderModule,
    NgxEchartsModule.forRoot({
        echarts: () => import('echarts')
    }),
    TranslateModule.forChild({
        loader: {
            provide: TranslateLoader,
            useFactory: createTranslateLoader,
            deps: [HttpClient]
        }
    }),
    RouterModule.forChild(routes),
    // Standalone Components
    ImageComponent,
    MarqueeComponent,
    TrendingComponent,
    CryptoNewsComponent,
    PaginationComponent,
    DropdownListComponent,
    // Standalone Pipes
    AbsValuePipe,
    TruncatePipe,
    FiatValuePipe,
    PlaceValuePipe,
    // Standalone Directives
    SortableDirective,
    LazyImgDirective,
    TokenBannerComponent
],
    providers: [ShortNumberPipe, CurrencyPipe, PlaceValuePipe]
})
export class CoinModule {}
